import { useQuery, UseQueryOptions } from "react-query";
import { useDispatch } from "react-redux";
import { api } from "@data-phone/react-resource-server-auth";
import { setAccounts } from "../redux/slices/accounts.slice";

const apiUrl = process.env.REACT_APP_AUTH_API;

export interface Account {
  id: string;
  accountcode: string;
  created_at: string;
  description: string;
  domain: string;
  enabled: boolean;
  parent_id: string;
  updated_at: string;
  name: string;
}

async function fetchAccount(id?: string): Promise<Account> {
  const endpoint = id
    ? `${apiUrl}/api/accounts/${id}?sub=true`
    : `${apiUrl}/api/accounts?sub=true`;
  const response = await api.get(endpoint);
  if (response.code !== 200) {
    throw new Error(`Failed to fetch account with id: ${id}`);
  }
  return response.data;
}

export function useAccounts(
  id?: string,
  options?: UseQueryOptions<Account | Account[], Error>
) {
  const dispatch = useDispatch();

  return useQuery<Account | Account[], Error>(
    id ? ["account", id] : "adminAccounts",
    () => (id ? fetchAccount(id) : fetchAccount()),
    {
      enabled: (id ? !!id : true),
      staleTime: Infinity,
      onSuccess: (data) => {
        const accountsArray = Array.isArray(data) ? data : [data];
        dispatch(setAccounts(accountsArray));
      },
      ...options,
    }
  );
}